export default __webpack_public_path__ + "static/media/login_page.f295f3d8.webm";